import React from 'react'
import Sidebar from '../Chats/ChatComponets/Sidebar'
import Chat from '../Chats/ChatComponets/Chat'

const ChatWindow = () => {
  return (
    <div className='home'>
      <div className="container">
        <Sidebar/>
        <Chat/>
      </div>
    </div>
  )
}

export default ChatWindow